<div *ngIf="loading" class="loading-container">
  <mat-progress-bar mode="indeterminate" color="primary" class="loading-bar"></mat-progress-bar>
</div>
<router-outlet></router-outlet>